import TSettingBusinessList from './index.vue';

TSettingBusinessList.install = app => {
  app.component(TSettingBusinessList.name, TSettingBusinessList);
};

export default TSettingBusinessList;
